
  import {defineComponent, onMounted, onUnmounted, reactive, toRefs, watch} from 'vue'
  import headerText from "@/layout/header/headerText";
  import useStore, {stateActionType} from "@/store";
  import {debounce} from "@/util/common";
  import {useRoute, useRouter} from "vue-router";
  import {getSectionPath} from "@/store/sesssion";

  export default defineComponent({
    name: 'index',
    setup() {
      const store = useStore()
      const route = useRoute()
      const router = useRouter()
      const dataMap = reactive({
        defaultActive: '/iot',
        headerText: headerText,
        menuOpen: false,
      })
      const switchPage = debounce(() => {
        if (window.innerWidth > 1060) {
          if (route.path === '/') {
            handleRoute({path: '/index'})
          }
          store.dispatch(stateActionType.SET_DEVICETYPE_ACTION, {deviceType: '1'})
          dataMap.headerText.menus[0].notShow = false
        } else {
          if (route.path === '/index' || route.path === '/') {//在首页的话
            handleRoute({path: '/iot/2'})
          }
          store.dispatch(stateActionType.SET_DEVICETYPE_ACTION, {deviceType: '2'})

          dataMap.headerText.menus[0].notShow = true
        }
      }, 50)

      //跳转页面
      const handleRoute = (menu) => {
        router.push({
          path: menu.path,
        })
        dataMap.menuOpen = false
      }
      watch(() => window.innerWidth, (newVal) => {
        switchPage()
      }, {
        immediate: true,
        deep: true
      })
      watch(() => route.path, (path) => {
        dataMap.defaultActive = path
        store.dispatch(stateActionType.SET_PATH_ACTION, {path: path})
      })
      addEventListener('resize', (e) => {
        switchPage()
      })
      onMounted(() => {
        if (getSectionPath()) {
          store.dispatch(stateActionType.SET_PATH_ACTION, {path: getSectionPath()})
          dataMap.defaultActive = getSectionPath()
        }
        switchPage()
      })
      onUnmounted(() => {
        removeEventListener('resize', (e) => {
          return
        })
      })
      return {
        handleRoute,
        ...toRefs(dataMap),
        store,
        route
      }
    }

  })
